import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSyncSubsetIssues = (matterId: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (issues: { id: string; label: string; text?: string }[]) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PUT, data: { issues } });
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/issues`, fetchConfig);
      if (!response.ok) throw new Error('Failed to sync issues');
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.SubsetIssues, { matterId, subsetId }]);
        queryClient.invalidateQueries([QueryEntity.Matter, { matterId }]);
      },
    },
  );
};
